// extracted by mini-css-extract-plugin
module.exports = {"menuComponent":"filterInput_menuComponent__3SnFB","iconColor":"filterInput_iconColor__33Kl6"};